module.exports = __webpack_public_path__ + "images/for_company_page/icon-dl-white_04fe04f6f1bfe83d8784d385d55999f5.svg";